<template>
  <div class="my-licence">
    <div class="account-card">
      <div class="account-card-header" style="margin-bottom:20px">
        <h4 class="account-card-title">审核确认书</h4>
      </div>
      <div class="form">
        <el-form :model="ruleForm" ref="ruleForm" label-width="150px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="公告编号:">
                <span>{{ ruleForm.code }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="公告标题:">
                <span>{{ ruleForm.title }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="看货开始时间:">
                <span>{{ ruleForm.inspectStartTime }} </span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="看货截止时间:">
                <span>{{ ruleForm.inspectEndTime }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="看货地点:">
                <span>{{ ruleForm.inspectAddress }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="titlepen">
        <el-table
          border
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column label="序号" type="index" width="50" align="center">
          </el-table-column>
          <el-table-column
            label="竞买人"
            width="120"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <span class="cell-link" @click="oncompName(scope.row)">
                {{ scope.row.compName }}</span
              ></template
            >
          </el-table-column>
          <el-table-column
            prop="inspectApplyTime"
            label="申请看货时间"
            width="150"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="straddrEc"
            label="所在地"
            width="120"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="inspectFeedbackTime"
            label="反馈看货时间"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="contName" label="联系人" align="center">
          </el-table-column>
          <el-table-column prop="contMobile" label="联系方式" align="center">
          </el-table-column>
          <!-- <el-table-column prop="auditWhetherView" label="状态" align="center">
          </el-table-column> -->
          <el-table-column prop="address" label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                @click="handleClick(scope.row, 0)"
                v-if="scope.row.auditWhether == 0"
                type="text"
                size="small"
                >审核</el-button
              >
              <el-button
                @click="handleClick(scope.row, 1)"
                v-else
                type="text"
                size="small"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-button type="primary" @click="down" class="down">返回</el-button>
    </div>
    <ReviewConfirmationDialog
      :show.sync="auditVisible"
      :clickRow="clickRow"
      :typequery="typequery"
      @success="onSuccess"
    />
    <ReviewSurrenderConfirmationDialog
      :show.sync="surrenderauditVisible"
      :clickRow="clickRow"
      @success="onSuccess"
      :typequery="typequery"
    />
  </div>
</template>
<script>
import ReviewConfirmationDialog from './components/ReviewConfirmationDialog.vue'
import ReviewSurrenderConfirmationDialog from './components/ReviewSurrenderConfirmationDialog.vue'
export default {
  components: {
    ReviewConfirmationDialog,
    ReviewSurrenderConfirmationDialog
  },
  data() {
    return {
      typequery: null,
      clickRow: {},
      surrenderauditVisible: false,
      auditVisible: false,
      number: '0',
      formAudit: {
        inspectFeedbackTime: '',
        inspectFeedbackNum: null,
        inspectFeedbackRemark: '',
        noticeFiles: [],
        inspectFeedbackPlace: ''
      },
      ruleForm: {
        title: '',
        code: '',
        bidStartTime: '',
        instructions: ''
      },
      tableData: [],
      multipleSelection: [],
      dialogTableVisible: false,
      choose: ''
    }
  },
  computed: {
    typeId() {
      return this.$route.query.id
    }
  },
  created() {
    this.noticeGet()
    this.sellerInspectList()
  },
  methods: {
    noticeFiles(val) {
      this.formAudit.noticeFiles = val
    },
    async noticeGet() {
      let data = await this.$api.materialdisposal.noticeGet({
        id: this.typeId
      })
      this.ruleForm = data
    },
    async sellerInspectList() {
      let data = await this.$api.materialdisposal.sellerSurveyList({
        noticeId: this.typeId,
        pageIndex: 1,
        pageSize: 9999
      })
      console.log(data)

      this.tableData = data.data
      //   this.ruleForm = data
    },
    operation() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('至少选择一个竞买人')
      } else {
        this.dialogTableVisible = true
      }
    },
    oncompName(o) {
      let query = {
        compCode: o.compCode,
        source: 'service'
      }
      this.$openNewPage('BuyerInformation', query)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      this.number = this.multipleSelection.length
    },
    selectable(row) {
      if (
        row.auditWhetherView === '待反馈' ||
        row.auditWhetherView === '未反馈'
      ) {
        return true
      }
    },
    onSuccess(val) {
      if (val) {
        this.sellerInspectList()
      }
    },
    handleClick(o, type) {
      this.clickRow = o
      if (o.surveyWhether == 1) {
        this.auditVisible = true
      } else {
        this.surrenderauditVisible = true
      }
      this.typequery = type
    },
    down() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="less" scoped>
.titleone {
  margin: 5px;
  margin-top: 15px;
  width: 10px;
  height: 22px;
  background: #2587ff;
  float: left;
}
.title {
  padding: 10px;
  height: 30px;
  margin-top: 10px;
  margin-bottom: 20px;
  background: #ecf5ff;
  font-size: 15px;
  line-height: 15px;
}
.titlesplic {
  float: right;
  color: royalblue;
  cursor: pointer;
}
.form {
  padding-right: 50px;
  padding-left: 100px;
}
.instructions {
  min-height: 120px;
  line-height: 20px;
  margin-left: 60px;
}
.titlepen {
  padding-left: 50px;
  position: relative;
}
.titlepenleft {
  position: absolute;
  // margin-left: 10px;
  top: 20px;
  left: 50x;
}
.titlepenright {
  float: right;
}
.down {
  margin: 20px 550px;
}
</style>
